/**
 * Resolve a subject to a Material Symbols ligature that the font really carries.
 *
 * The icon font renders an unknown ligature as its own text, so a bad value in
 * `subjects.icon_name` does not fail quietly — it prints the word across the
 * tile, which is how "FLASK" ended up on the homepage. Everything that reaches
 * the template goes through this allow list, so the worst case is a mortarboard.
 *
 * The database is still the source of truth: the migration that fills
 * `icon_name` uses this same set of names.
 */
/**
 * Every name held in `subjects.icon_name`, checked against the Material Symbols
 * Outlined codepoint list. Anything outside this set falls back rather than
 * being drawn, so a value the font does not carry can never print itself.
 *
 * When a subject is added with a new icon, add the name here too — otherwise it
 * quietly renders as a mortarboard.
 */
const ALLOWED = new Set([
  'account_balance', 'agriculture', 'apartment', 'bar_chart', 'biotech', 'bolt',
  'book', 'business_center', 'calculate', 'computer', 'design_services',
  'devices', 'directions_car', 'diversity_3', 'eco', 'engineering',
  'fitness_center', 'flight', 'functions', 'gavel', 'groups', 'handyman',
  'health_and_safety', 'history_edu', 'home', 'hotel', 'landscape', 'language',
  'memory', 'menu_book', 'mosque', 'movie', 'music_note', 'palette',
  'psychology', 'public', 'restaurant', 'school', 'science', 'self_improvement',
  'sports_soccer', 'storefront', 'theater_comedy', 'translate', 'trending_up',
  'work',
])

const FALLBACK = 'school'

/**
 * @param {{icon_name?: string|null}|null|undefined} subject
 * @returns {string} a ligature the icon font can draw
 */
export function subjectIcon (subject) {
  const name = subject?.icon_name
  return name && ALLOWED.has(name) ? name : FALLBACK
}

export default subjectIcon
